import { parseIntValue } from "helpers/parse";
import { STATUS_TOTAL, URL_KEYS } from "constants/dashboard";
import { INITIAL_LIMIT, INITIAL_PAGE } from "constants/common";

export function parsePage(searchParams) {
  return parseIntValue(searchParams.get(URL_KEYS.page)) ?? INITIAL_PAGE;
}

export function parsePerPage(searchParams) {
  return searchParams.get(URL_KEYS.perPage) ?? INITIAL_LIMIT;
}

export function parseSearchParam({ key, searchParams }) {
  return searchParams.get(key) ?? undefined;
}

export function parseStatusParam(searchParams) {
  return searchParams.get(URL_KEYS.status) === STATUS_TOTAL ? undefined : 1;
}
